import { render, staticRenderFns } from "./BundleModal.vue?vue&type=template&id=7538fd58&scoped=true"
import script from "./BundleModal.vue?vue&type=script&lang=js"
export * from "./BundleModal.vue?vue&type=script&lang=js"
import style0 from "./BundleModal.vue?vue&type=style&index=0&id=7538fd58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7538fd58",
  null
  
)

export default component.exports